import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Lock, Mail, Loader2 } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AdminLogin() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ email: "", password: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const response = await axios.post(`${API}/auth/login`, formData);
      localStorage.setItem("adminToken", response.data.access_token);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (error) {
      toast.error(error.response?.data?.detail || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FAF8F0] flex items-center justify-center px-6 py-12 relative">
      <div className="petal-left hidden lg:block" />
      <div className="petal-right hidden lg:block" />
      
      <div className="w-full max-w-md animate-fadeIn relative z-10">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 mb-4">
            <svg className="w-8 h-8 text-[#F0D9D5]" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C12 2 9 5 9 8C9 9.5 9.5 10.5 10 11.5C8.5 11 7 10.5 5 11C5 11 8 14 10.5 14C10 15 9 16.5 9 18C9 18 12 15 12 12C12 15 15 18 15 18C15 16.5 14 15 13.5 14C16 14 19 11 19 11C17 10.5 15.5 11 14 11.5C14.5 10.5 15 9.5 15 8C15 5 12 2 12 2Z"/>
            </svg>
            <span className="text-2xl text-[#676664] tracking-[0.15em]">MAHRA</span>
          </div>
          <p className="text-[#676664]/40 text-[11px] tracking-[0.2em] uppercase">Admin Portal</p>
        </div>

        <div className="bg-white p-10 border border-[#282828]/10">
          <h2 className="text-sm text-[#676664] mb-8 text-center tracking-wide">Sign In</h2>
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label className="text-[#676664]/60 text-[11px]">Email</Label>
              <div className="relative mt-2">
                <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#676664]/30" strokeWidth={1.5} />
                <Input type="email" value={formData.email} onChange={(e) => setFormData(p => ({...p, email: e.target.value}))} placeholder="admin@mahra.com" className="pl-12 py-6 border-[#282828]/10" data-testid="admin-email-input" required />
              </div>
            </div>
            <div>
              <Label className="text-[#676664]/60 text-[11px]">Password</Label>
              <div className="relative mt-2">
                <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-[#676664]/30" strokeWidth={1.5} />
                <Input type="password" value={formData.password} onChange={(e) => setFormData(p => ({...p, password: e.target.value}))} placeholder="Enter password" className="pl-12 py-6 border-[#282828]/10" data-testid="admin-password-input" required />
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full bg-[#9A7B4F] hover:bg-[#8B6B3F] text-white py-6 text-[11px] tracking-[0.15em] uppercase" data-testid="admin-login-btn">
              {loading ? <><Loader2 className="w-4 h-4 animate-spin mr-2" />Signing in...</> : "Sign In"}
            </Button>
          </form>
        </div>
        <p className="text-center text-[10px] text-[#676664]/30 mt-8 tracking-wide">Protected admin area</p>
      </div>
    </div>
  );
}
